import { useQuery } from 'react-query';
import { client } from '@frontend/features/common/services';
import { QueryKeys } from '@frontend/features/common/types';
import { PagedResponse } from '@bandido/shared/dtos';
import { RecentConversationDTO } from '@bandido/shared/types';

interface UseGetWpActiveConversationsParams {
  page?: number;
  limit?: number;
}

const fetchActiveConversations = async (params?: UseGetWpActiveConversationsParams): Promise<PagedResponse<RecentConversationDTO>> => {
  const searchParams = new URLSearchParams();
  
  if (params?.page) {
    searchParams.append('page', params.page.toString());
  }
  
  if (params?.limit) {
    searchParams.append('limit', params.limit.toString());
  }
  
  const queryString = searchParams.toString();
  const url = queryString ? `/whatsapp/active?${queryString}` : '/whatsapp/active';
  
  const { data } = await client.get(url);
  return data;
};

export const useGetWpActiveConversations = (params?: UseGetWpActiveConversationsParams) =>
  useQuery([QueryKeys.gupshupActiveConversations, params], () => fetchActiveConversations(params));
